function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAEvent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 269 173.006",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 150,
    style: {
      stroke: "rgb(122, 122, 122)",
      fill: "rgb(236, 236, 236)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.528,
    y: 64.938,
    width: 50,
    height: 30,
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(28, 255, 0)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.522,
    y: 9.4,
    width: 50,
    height: 30,
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(28, 255, 0)",
      transformOrigin: "100.522003px 24.4px"
    },
    transform: "matrix(0, 1, -1, 0, -8.877058029175, 1.850419998169)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.522,
    y: 9.4,
    width: 50,
    height: 30,
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(28, 255, 0)",
      transformOrigin: "100.515624px 24.359375px"
    },
    transform: "matrix(0, 1, -1, 0, 67.595337867737, 3.262663841248)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.378,
    y: 83.115,
    width: 50,
    height: 30,
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(28, 255, 0)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.192,
    y: 126.608,
    width: 47.57,
    height: 21.995,
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    d: "M 138.558 149.101 C 133.886 141.992 159.11 172.738 159.22 172.906"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.206,
    y: 138.632,
    width: 31.253,
    height: 11.921,
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(236, 236, 236)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    d: "M 35.942 149.201 C 31.27 142.092 56.494 172.838 56.604 173.006"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.59,
    y: 139.055,
    width: 31.253,
    height: 11.921,
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(236, 236, 236)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    x: 9.43,
    y: 77.738,
    transform: "matrix(0.45747703313827515, 0, 0, 0.5126979351043701, -1.3585469722747803, 44.00851058959961)"
  }, "Baby A"), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28,
      transformOrigin: "0.437498px 122.164074px"
    },
    x: -44.698,
    y: 131.866,
    transform: "matrix(0, 0.434843063354, -0.540358006954, 0, 91.091136045922, -96.134508005048)"
  }, "Baby B"), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    x: 19.418,
    y: 205.004,
    transform: "matrix(0.37068700790405273, 0, 0, 0.5126979351043701, 211.64219665527347, -2.3308451175689697)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(7, 0, 255)",
      fill: "rgb(219, 220, 255)"
    },
    cx: 167.921,
    cy: 66.934,
    rx: 11.347,
    ry: 11.524
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    x: 32.073,
    y: 221.353,
    transform: "matrix(0.24321401119232178, 0, 0, 0.3195210099220276, 152.80213928222656, -0.6915521025657654)"
  }, "Dr H"), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(7, 0, 255)",
      fill: "rgb(219, 220, 255)"
    },
    cx: 186.013,
    cy: 111.497,
    rx: 11.347,
    ry: 11.524
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    x: 144.753,
    y: 189.212,
    transform: "matrix(0.21955399215221405, 0, 0, 0.3195210099220276, 147.61334228515625, 53.56415939331055)"
  }, "Dr W"), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(7, 0, 255)",
      fill: "rgb(219, 220, 255)"
    },
    cx: 104.216,
    cy: 112.872,
    rx: 11.347,
    ry: 11.524
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    x: 144.753,
    y: 189.212,
    transform: "matrix(0.21955399215221405, 0, 0, 0.3195210099220276, 67.8244400024414, 55.217193603515625)"
  }, "MT"), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(7, 0, 255)",
      fill: "rgb(219, 220, 255)"
    },
    cx: 64.098,
    cy: 81.087,
    rx: 11.347,
    ry: 11.524
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    x: 144.753,
    y: 189.212,
    transform: "matrix(0.21955399215221405, 0, 0, 0.3195210099220276, 27.70603370666504, 23.432899475097656)"
  }, "LL"));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAEvent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/A_event.b8026cff.svg";
export { ForwardRef as ReactComponent };